import request from '@/utils/request'

export function provinceCity (query) {
  return request({
    url: '/wechat/province_city/',
    method: 'get',
    params: query
  })
}
